import Vue from 'vue'
import App from './App.vue'
import router from './router'
import axios from 'axios'

import i18n from './i18n.js'

import './registerServiceWorker'

//Vue.config.productionTip = false

import {Icon} from 'leaflet'
//import 'leaflet/dist/leaflet.css'

import VueMatomo from 'vue-matomo'

// this part resolve an issue where the markers would not appear
delete Icon.Default.prototype._getIconUrl

Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
})

var vm = new Vue({
  data: {
    loading: false,
    BPRoutes: [],
    BPPoints: [],
    content: {},
    solvedQuizes: [],
    codelist: [],
    teilnehmerid: [],
    currentlocation: {lat: null, lon: null},
  },
  watch: {
    solvedQuizes: {
      handler() {
        //console.log('Quizdata changed!');
        localStorage.setItem('solvedQuizes', JSON.stringify(this.solvedQuizes))
      },
      deep: true,
    },
    codelist: {
      handler() {
        console.log('codelist changed!')
        localStorage.setItem('codelist', JSON.stringify(this.codelist))
      },
      deep: true,
    },
  },
  mounted() {
    if (localStorage.getItem('codelist')) {
      this.codelist = JSON.parse(localStorage.getItem('codelist'))
    }

    let self = this

    if (navigator.geolocation) {
      var id, target, options

      options = {
        enableHighAccuracy: false,
        timeout: 5000,
        maximumAge: 0,
      }

      id = navigator.geolocation.watchPosition(function (position) {
        console.log(position.coords.latitude, position.coords.longitude)
        self.currentlocation.lat = position.coords.latitude
        self.currentlocation.lon = position.coords.longitude
      },
      function (err) {
        console.warn('ERROR(' + err.code + '): ' + err.message)
        if (err.code == 1) {
          // alert("Error: Access is denied!");
        } else if (err.code == 2) {
          //  alert("Error: Position is unavailable!");
        }
      }, options)

      /*
            navigator.geolocation.getCurrentPosition(function (position) {
              console.log(position.coords.latitude, position.coords.longitude)
              self.currentlocation.lat = position.coords.latitude
              self.currentlocation.lon = position.coords.longitude
            })*/
    }

    this.loading = true
    axios
      .get(process.env.VUE_APP_API_ENDPOINT + 'routen/list')
      .then(response => {
        //console.log(response.data);
        this.BPRoutes = response.data
      })
      .catch(error => {
        //console.log(error)
        this.errored = true
      })
      .finally(() => this.loading = false)
    axios
      .get(process.env.VUE_APP_API_ENDPOINT + 'punkte/list')
      .then(response => {
        //console.log(response.data);
        this.BPPoints = response.data
      })
      .catch(error => {
        //console.log(error)
        this.errored = true
      })
      .finally(() => this.loading = false)
    axios
      .get(process.env.VUE_APP_API_ENDPOINT + 'routen/contentapi')
      .then(response => {
        //console.log(response.data);
        this.content = response.data
      })
      .catch(error => {
        //console.log(error)
        this.errored = true
      })
      .finally(() => this.loading = false)
  },
  i18n,
  router,
  render: h => h(App),
}).$mount('#app')

Vue.use(VueMatomo, {
  // Configure your matomo server and site by providing
  host: 'https://statistik.eno-intern.de/',
  siteId: 2,

  // Changes the default .js and .php endpoint's filename
  // Default: 'matomo'
  trackerFileName: 'matomo',

  // Overrides the autogenerated tracker endpoint entirely
  // Default: undefined
  // trackerUrl: 'https://example.com/whatever/endpoint/you/have',

  // Overrides the autogenerated tracker script path entirely
  // Default: undefined
  // trackerScriptUrl: 'https://example.com/whatever/script/path/you/have',

  // Enables automatically registering pageviews on the router
  router: router,

  // Enables link tracking on regular links. Note that this won't
  // work for routing links (ie. internal Vue router links)
  // Default: true
  enableLinkTracking: true,

  // Require consent before sending tracking information to matomo
  // Default: false
  requireConsent: false,

  // Whether to track the initial page view
  // Default: true
  trackInitialView: true,

  // Run Matomo without cookies
  // Default: false
  disableCookies: true,

  // Require consent before creating matomo session cookie
  // Default: false
  requireCookieConsent: false,

  // Enable the heartbeat timer (https://developer.matomo.org/guides/tracking-javascript-guide#accurately-measure-the-time-spent-on-each-page)
  // Default: false
  enableHeartBeatTimer: false,

  // Set the heartbeat timer interval
  // Default: 15
  heartBeatTimerInterval: 15,

  // Whether or not to log debug information
  // Default: false
  debug: false,

  // UserID passed to Matomo (see https://developer.matomo.org/guides/tracking-javascript-guide#user-id)
  // Default: undefined
  userId: undefined,

  // Share the tracking cookie across subdomains (see https://developer.matomo.org/guides/tracking-javascript-guide#measuring-domains-andor-sub-domains)
  // Default: undefined, example '*.example.com'
  cookieDomain: undefined,

  // Tell Matomo the website domain so that clicks on these domains are not tracked as 'Outlinks'
  // Default: undefined, example: '*.example.com'
  domains: undefined,

  // A list of pre-initialization actions that run before matomo is loaded
  // Default: []
  // Example: [
  //   ['API_method_name', parameter_list],
  //   ['setCustomVariable','1','VisitorType','Member'],
  //   ['appendToTrackingUrl', 'new_visit=1'],
  //   etc.
  // ]
  preInitActions: [],
})

window._paq.push
